import { StatusProps } from "@eworkit/iris";

import { IConsultantProfile, IShortConsultantProfile } from "./types-ensure";

export const isProfileConnected = (cp: IConsultantProfile) => {
  const rejectedRequestToJoin = cp.requestToJoin && cp.requestToJoin.status !== "REJECTED";
  return !!cp.sharedProfile || !!rejectedRequestToJoin;
};

export const getConsultantProfileCompany = (profile: IConsultantProfile) => {
  return profile.sharedProfile ? profile.sharedProfile.company : undefined;
};

export const getProfileStatusTranslationKey = (profile: IShortConsultantProfile) => {
  if (profile.status === "PENDING") {
    if (profile.requestToJoin) return "COMPANY.DETAIL.LIST.PROFILE_NOT_APPROVED";
    else return "COMPANY.DETAIL.LIST.PROFILE_NOT_REGISTERED";
  } else if (profile.status === "NOT_INVITED") {
    return "COMPANY.DETAIL.LIST.PROFILE_NOT_INVITED";
  }

  return "";
};

export const getProfileStatusVariant = (profile: IShortConsultantProfile): StatusProps["variant"] | undefined => {
  if (profile.status === "PENDING") {
    if (profile.requestToJoin) return "info";
    else return "secondary";
  } else if (profile.status === "NOT_INVITED") {
    return "secondary";
  }

  return undefined;
};
